// extracted by mini-css-extract-plugin
export var border = "IntroHeroWithPreHeading-module--border--effbc";
export var bordersection = "IntroHeroWithPreHeading-module--bordersection--cdbf8";
export var herowithimagecontainer = "IntroHeroWithPreHeading-module--herowithimagecontainer--fb753";
export var preheading = "IntroHeroWithPreHeading-module--preheading--5bfe0";
export var preheadingtext = "IntroHeroWithPreHeading-module--preheadingtext--8cdcf";
export var textcontainer = "IntroHeroWithPreHeading-module--textcontainer--03ee3";
export var title = "IntroHeroWithPreHeading-module--title--29e6b";
export var topsectionouter = "IntroHeroWithPreHeading-module--topsectionouter--7259f";